import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 15,
	viewBox: "0 0 18 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.95696 15L8.42385 13.4186L4.03392 8.68601H18V6.44957L3.90816 6.44957L8.42385 1.5814L6.95696 9.53674e-07L0 7.5L6.95696 15Z",
		fill: "#0E4EFB"
	})
});
export default SvgBack;
